import React from "react"
import { theme } from "../theme/default"

export const UserIcon = ({ color = "blue", ...props }) => {
  return (
    <svg
      width='37'
      height='38'
      {...props}
      viewBox='0 0 37 38'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.7775 18.3215C23.7481 18.3215 27.7776 14.292 27.7776 9.3214C27.7776 4.35077 23.7481 0.321289 18.7775 0.321289C13.8068 0.321289 9.77734 4.35077 9.77734 9.3214C9.77734 14.292 13.8068 18.3215 18.7775 18.3215Z'
        fill={color ? theme.colors[color] : "#554DF1"}
      />
      <path
        d='M20.5946 23.7217H16.9603C14.8284 23.727 12.7187 24.0629 10.7516 24.7103C8.78456 25.3577 6.99869 26.3039 5.49596 27.4948C3.99324 28.6858 2.8031 30.0981 1.99349 31.6513C1.18388 33.2044 0.770661 34.8679 0.777425 36.5468C0.777425 36.7259 0.867732 36.8975 1.02848 37.0241C1.18922 37.1507 1.40724 37.2218 1.63457 37.2218H35.9204C36.1583 37.2048 36.3791 37.1172 36.5382 36.9769C36.6973 36.8366 36.7829 36.6539 36.7775 36.4658C36.7685 33.0881 35.0606 29.8507 32.0277 27.4622C28.9948 25.0738 24.8838 23.7288 20.5946 23.7217Z'
        fill={color ? theme.colors[color] : "#554DF1"}
      />
    </svg>
  )
}
